import ColoredIcon from '#base/resources/icons/rtic-custom-colored.svg';
import EngravedIcon from '#base/resources/icons/rtic-custom-gray.svg';
import classnames from 'classnames';
import React from 'react';

const graphicTypes = [
  {
    value: 'color',
    label: 'Color',
    icon: ColoredIcon,
  },
  {
    value: 'engraved',
    label: 'Engraved',
    icon: EngravedIcon,
  },
];

export const GraphicTypeSelect = ({ value, onSelect, size, className }) => {
  return (
    <div className={className}>
      <div className='t-mb-5 t-inline-flex t-w-full t-items-center t-rounded-xl t-bg-neutral-100'>
        {graphicTypes.map((gt, i) => {
          return (
            <span
              key={i}
              className={classnames(
                't-inline-flex t-grow t-cursor-pointer t-items-center t-justify-center t-gap-1 t-rounded-xl t-transition',
                {
                  't-border t-border-neutrals-light-grey t-bg-white t-font-bold': gt.value === value,
                  't-h-14 md:t-w-[155px]': size !== 'sm',
                  't-h-10 t-text-xs md:t-w-[115px]': size === 'sm',
                }
              )}
              onClick={() => onSelect(gt.value)}>
              {gt.icon && <img src={gt.icon} className='t-max-h-[22px] t-max-w-[22px]' />}
              <span>{gt.label}</span>
            </span>
          );
        })}
      </div>
    </div>
  );
};
